module.exports = __webpack_public_path__ + "static/media/how-it-works1.b41482ca.png";